/**
 * Parses an in-app action and returns a ToolChirpCompatible for CopilotV2
 */
import { convertCommunicationSummaryAction } from '../_internal/actions/communicationSummaryConverter';
import { convertCompanyNewsAction } from '../_internal/actions/companyNewsConverter';
import { convertCompanyTechStackAction } from '../_internal/actions/companyTechStackConverter';
import { convertContentRewriteAction } from '../_internal/actions/contentRewriteConverter';
import { convertCrmObjectSummaryAction } from '../_internal/actions/crmObjectSummaryConverter';
import { convertCrmObjectUpsertAction } from '../_internal/actions/crmObjectUpsertConverter';
import { convertFeedbackSubmissionSummaryAction } from '../_internal/actions/feedbackSubmissionSummaryConverter';
import { convertHubspotHowToAction } from '../_internal/actions/hubspotHowToConverter';
import { convertInvoicesCreateAction } from '../_internal/actions/invoicesCreateConverter';
import { convertObjectEngagementsSummaryAction } from '../_internal/actions/objectEngagementsSummaryConverter';
import { convertReportingInsightsCopilotGenerationAction } from '../_internal/actions/reportingInsightsCopilotGenerationConverter';
import { convertSummarizeActivityFeedAction } from '../_internal/actions/summarizeActivityFeedConverter';
import { convertSummarizeArticleAction } from '../_internal/actions/summarizeArticleConverter';
import { convertTextGenerationAction } from '../_internal/actions/textGenerationConverter';
import { convertWorkflowCreateAction } from '../_internal/actions/workflowCreateConverter';
import { convertWorkflowGenerationAction } from '../_internal/actions/workflowGenerationConverter';
import * as V1_ACTIONS from '../constants/CopilotInAppActionTypes';
/**
 * DO NOT USE THIS FUNCTION OUTSIDE OF COPILOT V2 LOGIC
 * Converts a legacy in-app action to a V2 tool input
 * @param inAppActionLegacy The legacy action to convert
 * @returns ToolChirpCompatible | undefined - The converted tool input in V2 format
 */
export const convertV1ActionToV2ToolInput = inAppActionLegacy => {
  // if there's no corresponding V1 action then there will be no V2 tool to convert
  if (!inAppActionLegacy) {
    return undefined;
  }
  const {
    intent
  } = inAppActionLegacy;
  switch (intent) {
    case V1_ACTIONS.COMPANY_NEWS:
      return convertCompanyNewsAction(inAppActionLegacy);
    case V1_ACTIONS.COMPANY_TECH:
      return convertCompanyTechStackAction(inAppActionLegacy);
    case V1_ACTIONS.CONTENT_REWRITE:
      return convertContentRewriteAction(inAppActionLegacy);
    case V1_ACTIONS.FEEDBACK_SUBMISSION_SUMMARY:
      return convertFeedbackSubmissionSummaryAction(inAppActionLegacy);
    case V1_ACTIONS.HUBSPOT_HOW_TO:
      return convertHubspotHowToAction(inAppActionLegacy);
    case V1_ACTIONS.COMMUNICATION_SUMMARY:
      return convertCommunicationSummaryAction(inAppActionLegacy);
    case V1_ACTIONS.OBJECT_ENGAGEMENTS_SUMMARY:
      return convertObjectEngagementsSummaryAction(inAppActionLegacy);
    case V1_ACTIONS.OBJECT_SUMMARY:
      return convertCrmObjectSummaryAction(inAppActionLegacy);
    case V1_ACTIONS.OBJECT_UPDATE:
      return convertCrmObjectUpsertAction(inAppActionLegacy);
    case V1_ACTIONS.INVOICES_CREATE:
      return convertInvoicesCreateAction(inAppActionLegacy);
    case V1_ACTIONS.REPORTING_INSIGHTS_COPILOT_GENERATION:
      return convertReportingInsightsCopilotGenerationAction(inAppActionLegacy);
    case V1_ACTIONS.SUMMARIZE_ACTIVITY_FEED:
      return convertSummarizeActivityFeedAction(inAppActionLegacy);
    case V1_ACTIONS.SUMMARIZE_ARTICLE:
      return convertSummarizeArticleAction(inAppActionLegacy);
    case V1_ACTIONS.WORKFLOW_CREATE:
      return convertWorkflowCreateAction(inAppActionLegacy);
    case V1_ACTIONS.WORKFLOW_GENERATION:
      return convertWorkflowGenerationAction(inAppActionLegacy);
    case V1_ACTIONS.TEXT_GENERATION:
      return convertTextGenerationAction(inAppActionLegacy);
    // TODO - add handler for CRM_OBJECT_SEARCH since there is no v1 action for it
    default:
      return undefined;
  }
};